import React from 'react';
import LegalLayout, { LegalSection } from './LegalLayout';

const EMAIL = 'aryanshivhare004@gmail.com';

const TermsOfService = () => {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="June 2026" canonical="https://aryanshivhare.com/terms-of-service" description="Terms of Service for aryanshivhare.com — the rules and conditions for using this website and its content.">
      <p>
        Welcome to aryanshivhare.com (the "Site"). By accessing or using this Site, you agree to be
        bound by these Terms of Service. If you do not agree with any part of these terms, please do
        not use the Site.
      </p>

      <LegalSection heading="1. Acceptance of Terms">
        <p>
          By accessing and using this Site, you accept and agree to be bound by these Terms of
          Service and our Privacy Policy. These terms apply to all visitors and users of the Site.
        </p>
      </LegalSection>

      <LegalSection heading="2. Intellectual Property">
        <p>
          All content on this Site — including text, articles, graphics, logos, images, and
          design — is the property of Aryan Shivhare and is protected by applicable copyright and
          intellectual property laws. You may not reproduce, distribute, or republish any content
          without prior written permission.
        </p>
      </LegalSection>

      <LegalSection heading="3. Use License">
        <p>
          You are granted a limited, non-exclusive license to access and view the content on this
          Site for personal, non-commercial use. Under this license you may not:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Modify or copy the materials for commercial purposes.</li>
          <li>Use the materials for any unlawful purpose.</li>
          <li>Attempt to reverse-engineer any software contained on the Site.</li>
          <li>Remove any copyright or proprietary notations from the materials.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="4. Content & Advice Disclaimer">
        <p>
          The content on this Site, including blog articles and marketing insights, is provided for
          general informational purposes only. It does not constitute professional, legal, or
          financial advice. You should not rely solely on this information when making business
          decisions, and results described are not guarantees of future performance.
        </p>
      </LegalSection>

      <LegalSection heading="5. Newsletter & Communications">
        <p>
          By subscribing to our newsletter, you consent to receive periodic emails. You may
          unsubscribe at any time using the link provided in each email.
        </p>
      </LegalSection>

      <LegalSection heading="6. Third-Party Links & Advertising">
        <p>
          This Site may contain links to third-party websites and display third-party
          advertisements (including via Google AdSense). We are not responsible for the content,
          accuracy, or practices of any third-party sites or advertisers.
        </p>
      </LegalSection>

      <LegalSection heading="7. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Aryan Shivhare shall not be liable for any direct,
          indirect, incidental, or consequential damages arising out of your use of, or inability to
          use, this Site or its content.
        </p>
      </LegalSection>

      <LegalSection heading="8. Accuracy of Materials">
        <p>
          The materials on this Site may include technical, typographical, or photographic errors.
          We do not warrant that any content is accurate, complete, or current, and we may make
          changes at any time without notice.
        </p>
      </LegalSection>

      <LegalSection heading="9. Modifications">
        <p>
          We may revise these Terms of Service at any time without notice. By continuing to use the
          Site, you agree to be bound by the then-current version of these terms.
        </p>
      </LegalSection>

      <LegalSection heading="10. Governing Law">
        <p>
          These terms are governed by and construed in accordance with the laws of Germany, and you
          irrevocably submit to the exclusive jurisdiction of the courts in Berlin, Germany.
        </p>
      </LegalSection>

      <LegalSection heading="11. Contact">
        <p>
          For any questions regarding these Terms of Service, contact us at{' '}
          <a href={`mailto:${EMAIL}`} className="text-gold underline underline-offset-4 hover:opacity-70">
            {EMAIL}
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
};

export default TermsOfService;
